import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import { List } from 'immutable'
import className from 'classnames'

import Bootstrap from 'bootstrap' // eslint-disable-line no-unused-vars

// Modules
import { ADD_SITE_PATH } from 'config'
import { selectors } from 'modules/sites'
import { getSubscriptionPlan } from 'modules/subscriptions';

// Components
import SiteItem from './site-item'
import UsageBar from './usage-bar'


const Sites = ({ sites, planId }) => {
  return (
    <div className="sites">
      <div className="row">
        <div className="col-sm-3 col-md-2 mb-3">
          <Link to={ ADD_SITE_PATH } className="btn btn-primary btn-block">
            Add Site
          </Link>
        </div>
        {/* TODO: Don't show this section if current plan is unlimited */}
        <div className="col-sm-6 offset-sm-3 offset-md-4 col-lg-4 offset-lg-6 mb-3">
          <div className={className('row', { hidden: planId === 'cacheready_unlimited' })}>
            <label className="col-2 col-sm-3 col-md-2 col-form-label">Usage: </label>
            <div className="col-10 col-sm-9 col-md-10">
              <UsageBar />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        { sites.map(site => (
          <div className="col-lg-4 col-md-6" key={ site.key }>
            <SiteItem site={ site } />
          </div>
        ),
        ) }
      </div>
    </div>
  )
}

Sites.propTypes = {
  sites: PropTypes.instanceOf(List).isRequired,
  planId: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  sites: selectors.getAllSites,
  planId: getSubscriptionPlan,
});

export default connect(mapStateToProps)(Sites)



// WEBPACK FOOTER //
// ./src/components/sites/sites.js